import React from "react";
import "./theme.css";
import AuditPage from "./pages/AuditPage";
import LandingPage from "./pages/LandingPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import { ContactUs } from "./components/layout/contactus/contact";
import TermsAndConditions from "./pages/Terms&Conditions";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import RefundPolicy from "./pages/RefundPolicy";
import CookiePolicy from "./pages/CookiePolicy";
import ShippingPolicy from "./pages/ShippingPolicy";
import ReportPage from "./pages/AuditReportPage";
import ScrollToTop from "./components/ScrollToTop";
import BlogListPage from "./pages/BlogList";
import BlogPage from "./pages/BlogPage";
import AboutPage from "./pages/AboutPage";
import ErrorPage from "./pages/ErrorPage";
import NotFoundPage from "./pages/Error404";
import ComingSoon from "./pages/ComingSoon";

// Toggle this
const COMING_SOON_MODE = false;

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />

      <Routes>
        {COMING_SOON_MODE ? (
          <>
            {/* Every route renders the Coming Soon page */}
            <Route path="*" element={<ComingSoon />} />
          </>
        ) : (
          <>
            <Route path="/" element={<LandingPage />} />
            <Route path="/audit" element={<AuditPage />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsAndConditions />} />
            <Route path="/refund" element={<RefundPolicy />} />
            <Route path="/cookies" element={<CookiePolicy />} />
            <Route path="/shipping" element={<ShippingPolicy />} />
            <Route path="" element={<Navigate to="/" replace />} />
            <Route path="/report" element={<ReportPage />} />
            <Route path="/blog" element={<BlogListPage />} />
            <Route path="/blogs/:idOrSlug" element={<BlogPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/error" element={<ErrorPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </>
        )}
      </Routes>
    </BrowserRouter>
  );
}

export default App;